import type { WhenFilter } from '@spot/shared';

import type { CategorySlug } from './categories';

/** Map filters (S1 chips). `undefined` = «Усі» / no time filter. */
export interface MapFilters {
	category?: CategorySlug | undefined;
	when?: WhenFilter | undefined;
}

/** Tapping the selected chip again clears it (back to «Усі» / any time). */
export function toggle<T>(current: T | undefined, next: T | undefined): T | undefined {
	return current === next ? undefined : next;
}

/** Query params for the events API; absent filters are omitted. */
export function filterParams(filters: MapFilters): { category?: string; when?: WhenFilter } {
	return {
		...(filters.category === undefined ? {} : { category: filters.category }),
		...(filters.when === undefined ? {} : { when: filters.when }),
	};
}

/** Badge on the «Фільтри» button: filters set inside the sheet (category has its own visible row). */
export function activeFilterCount(filters: MapFilters): number {
	return filters.when === undefined ? 0 : 1;
}

/** «Зараз поруч» (T-208): one tap sets the «Зараз» time filter, the next tap clears it. */
export function toggleNowMode(filters: MapFilters): MapFilters {
	return { ...filters, when: toggle(filters.when, 'now') };
}
